import React from 'react';

const ReplenishmentStrategySelector = (props) => {

    const replenishmentStrategyOptions = [
        {id: 'SCHUHEDE', label: 'schuhe.de'},
        {id: 'IPOS', label: 'IPOS'}
    ];

    const onChange = (event) => {
        props.onChange(event.target.value);
    };

    const renderPleaseSelect = () => {
      if(props.showPleaseSelectOpt) {
          return (
              <option key='' value=''>Bitte wählen</option>
          )
      }
    };

    return (
        <div style={{width: props.width}}>
            <div className="input-group">
                <select name="select"
                        id="select"
                        value={props.value ? props.value : ''}
                        className="form-control"
                        onChange={onChange}>
                    {renderPleaseSelect()}
                    {replenishmentStrategyOptions.map(option => {
                        return <option key={option.id} value={option.id}>{option.label}</option>
                    })}
                </select>
            </div>
        </div>
    );
};

ReplenishmentStrategySelector.defaultProps = {width: '200px', showPleaseSelectOpt: false, value: null};

export default ReplenishmentStrategySelector;



// WEBPACK FOOTER //
// ./src/admin/retailer/ReplenishmentStrategySelector.js